var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6018,
    cy: 13,
    r: 12.5,
    fill: "#C1C5D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3252 14.325C14.1536 14.5092 13.9466 14.657 13.7166 14.7595C13.4866 14.8619 13.2383 14.9171 12.9866 14.9215C12.7348 14.9259 12.4847 14.8796 12.2513 14.7853C12.0178 14.691 11.8057 14.5507 11.6276 14.3726C11.4496 14.1946 11.3092 13.9825 11.2149 13.749C11.1206 13.5155 11.0743 13.2655 11.0788 13.0137C11.0832 12.762 11.1383 12.5137 11.2408 12.2837C11.3433 12.0537 11.491 11.8467 11.6752 11.675M16.7127 16.7125C15.6444 17.5269 14.3434 17.9781 13.0002 18C8.62524 18 6.12524 13 6.12524 13C6.90268 11.5512 7.98095 10.2854 9.28774 9.28752L16.7127 16.7125ZM11.6877 8.15002C12.118 8.04932 12.5584 7.99898 13.0002 8.00002C17.3752 8.00002 19.8752 13 19.8752 13C19.4959 13.7098 19.0434 14.378 18.5252 14.9938L11.6877 8.15002Z",
    stroke: "#242833",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12524 6.125L19.8752 19.875",
    stroke: "#242833",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/closeEye.fe65f766b28543ca1379fdc17c015bf3.svg";
export { ForwardRef as ReactComponent };